





























































































































import { Component, Mixins, Prop } from "vue-property-decorator";
import HelperDinamicallyForm from "@/components/DinamicallyForm/HelperDinamicallyForm";
import { MenuItem } from "@/components/Menu/menu-item";
import { datatypes } from "@/components/DataTableGenerico/datatypes";
import menu_optionModule from "@/store/modules/menu_option-module";
import { DynamicChangeEventClass } from "@/components/DinamicallyForm/DynamicChangeEventClass";
import { UtilsString } from "@/utils/utils-string";
import DxColorBox from "devextreme-vue/color-box";
import IconSelector from "@/components/IconSelector/IconSelector.vue";
import RouteSelector from "@/components/RouteSelector/RouteSelector.vue";
import mantenimiento_permisoModule from "@/store/modules/mantenimiento_permiso-module";
@Component({
  components: { DxColorBox, IconSelector, RouteSelector },
})
export default class MenuFormulario extends Mixins(HelperDinamicallyForm) {
  public item_pantalla: MenuItem = new MenuItem();
  public opcionesOrden: { codigo: string; descripcion: string }[] = [];
  public permisos: { codigo: string; descripcion: string }[] = [];
  public permissionSelected: { codigo: string; descripcion: string }[] = [];
  public dialogPermission = false;
  public searchPermission = "";

  public async OnCreated() {
    this.ShowLoading();

    await menu_optionModule.getmenu_options();
    await mantenimiento_permisoModule.getmantenimiento_permisos();
    // Campo orden con opciones descriptivas
    this.opcionesOrden = this.getOpcionesOrden(this.item_pantalla.id_padre);
    console.log(this.opcionesOrden);
    if (this.getparamId().HayParametro) {
      await menu_optionModule.getmenu_option(this.getparamId().Parametro);
      this.item_pantalla = menu_optionModule.menu_option;
    }

    //Para la clonacion automatica
    this.BasicElement = this.item_pantalla;
    console.log(this.item_pantalla);
    this.HideLoading();
  }

  public CreateFields() {
    //Empezamos a crear una pantalla
    //configuracion de la clonacion automatica

    //Monmtamos una lista de permsos a partir del modulo de permisos
    this.permisos_getter.forEach((permiso) => {
      this.permisos.push({
        codigo: permiso.permiso_menu,
        descripcion: permiso.nombre,
      });
    });

    // Si hay un permiso seleccionado, marcarlo
    if (this.item_pantalla.permission) {
      const selected = this.permisos.find(
        (p) => p.codigo === this.item_pantalla.permission
      );
      if (selected) {
        this.permissionSelected = [selected];
      }
    }

    this.AddFormItemDataDefaultSlot(
      this.item_pantalla.icon_fntaws,
      "Icono",
      "icon_fntaws",
      60
    )
      .isRequired()
      .Dimesiones(12, 10, 6);

    this.AddFormItemDataDefaultString(
      this.item_pantalla.text,
      "Nombre",
      "text",
      datatypes.maxlength
    )
      .isRequired()
      .Dimesiones(12, 10, 6);
    this.AddFormItemDataDefaultSlot(
      this.item_pantalla.color,
      "Color",
      "color",
      60
    )
      .isRequired()
      .Dimesiones(12, 4, 2);
    this.AddFormItemDataDefaultBoolean(
      this.item_pantalla.url_fija,
      "Url",
      "url_fija",
      1,
      "Poner la url fija",
      "Concatenar con el padre"
    ).Dimesiones(12, 6, 4);
    this.AddFormItemDataDefaultSlot(
      this.item_pantalla.link,
      "Link",
      "link",
      datatypes.maxlength
    )
      .isRequired()
      .Dimesiones(12, 10, 6);
    this.AddFormItemDataDefaultSlot(
      this.item_pantalla.permission,
      "Permiso del Menú",
      "slot_permission",
      60
    ).Dimesiones(12, 10, 6);

    this.AddFormItemDataDefaultNumber(
      this.item_pantalla.id_padre,
      "Padre",
      "id_padre"
    )
      .CreateComboSingleCodigoDescripcionNames(
        menu_optionModule.menu_options,
        "text",
        "id"
      )
      .Dimesiones(12, 10, 6);

    this.AddFormItemDataDefaultNumber(
      this.item_pantalla.orden,
      "Posición en el menú",
      "orden"
    ).Dimesiones(12, 10, 6);

    this.AddFormItemDataDefaultSlot(
      this.opcionesOrden,
      "Mostrar posiciones",
      "slot_orden",
      60
    ).Dimesiones(12, 10, 6);
  }

  public click_item_orden(item: any) {
    console.log(item);
    this.SetFormItem("orden").data = item.codigo;
  }

  public set_orden(e: DynamicChangeEventClass) {
    console.log(this.SetFormItem(e.VariableName).data);
    var valor = UtilsString.ValueOf(e.NewValue);
    this.SetFormItem(e.VariableName).data = valor;
    this.item_pantalla.orden = Number(valor);
  }

  /**
   * Genera opciones descriptivas de orden para el combo
   */
  private getOpcionesOrden(
    idPadre: number | undefined
  ): { codigo: string; descripcion: string }[] {
    // Obtener hermanos (elementos con el mismo padre) ordenados
    const hermanos = menu_optionModule.menu_options
      .filter((m) => {
        if (idPadre === undefined || idPadre === null || idPadre === 0) {
          return !m.id_padre || m.id_padre === 0;
        } else {
          return m.id_padre === idPadre;
        }
      })
      .filter((m) => m.id !== this.item_pantalla.id) // Excluir el item actual si está editando
      .sort((a, b) => (a.orden || 0) - (b.orden || 0));

    var opciones: { codigo: string; descripcion: string }[] = [];

    if (hermanos.length === 0) {
      // Si no hay hermanos, solo una opción
      opciones.push({ codigo: "1", descripcion: "Primera posición" });
    } else {
      // Opción para poner al inicio
      opciones.push({
        codigo: "1",
        descripcion: "⬆️ Al inicio (antes de todo)",
      });

      // Opciones para poner después de cada hermano existente
      hermanos.forEach((hermano, index) => {
        opciones.push({
          codigo: String(index + 2),
          descripcion: `↓ Después de: ${hermano.text}`,
        });
      });
    }

    return opciones;
  }

  get permisos_getter() {
    return mantenimiento_permisoModule.mantenimiento_permisos;
  }

  public click_item_permission(item: any) {
    console.log("Permiso seleccionado:", item);
    this.SetFormItem("permission").data = item.codigo;
    this.item_pantalla.permission = item.codigo;
    this.permissionSelected = [item];
  }

  get filteredPermisos() {
    if (!this.searchPermission) {
      return this.permisos;
    }
    const search = this.searchPermission.toLowerCase();
    return this.permisos.filter(
      (p) =>
        p.descripcion.toLowerCase().includes(search) ||
        p.codigo.toLowerCase().includes(search)
    );
  }

  public getPermissionName(codigo: string): string {
    if (!codigo) return "Sin permiso asignado";
    const permiso = this.permisos.find((p) => p.codigo === codigo);
    return permiso ? permiso.descripcion : codigo;
  }

  public selectPermissionAndClose(item: any) {
    this.click_item_permission(item);
    this.dialogPermission = false;
  }

  /**
   * Handler para cambios en el formulario
   */
  MiEventChange(e: DynamicChangeEventClass) {
    console.log(e);
    // Si cambia el padre, seleccionar "Al final" por defecto
    if (e.VariableName === "id_padre") {
      this.opcionesOrden = this.getOpcionesOrden(e.NewValue);
      // Seleccionar la última opción (al final)
      this.SetFormItem("orden").data = this.opcionesOrden.length;
    }
  }

  public set_text_icon(e: DynamicChangeEventClass) {
    var valor = UtilsString.ValueOf(e.NewValue);
    var re = '"></i>';
    var valor = valor.replace(re, "");
    re = '<i class="';
    valor = valor.replace(re, "");
    this.SetFormItem(e.VariableName).data = valor;
  }

  public Insertar(object: MenuItem) {
    object.permission = this.item_pantalla.permission;
    console.log(object);
    menu_optionModule.guardarmenu_option(object).then(() => {
      this.$router.push({
        name: this.RouterNames().menu_plataforma_lista,
      });
      setTimeout(() => this.SenToastGuardado(), 500);
    });
  }

  public Actualizar(object: MenuItem) {
    object.permission = this.item_pantalla.permission;
    console.log(object);
    menu_optionModule.modificarmenu_option(object).then(() => {
      this.$router.push({
        name: this.RouterNames().menu_plataforma_lista,
      });
      setTimeout(() => this.SenToastActualizado(), 500); //guardo correctamente y me cierro
    });
  }
}
